import React from 'react';
import { Form, Input } from 'antd';

const Url = () => {
    return (
        <Form.Item
            label="Adres URL"
            name="slug"
            rules={[
                {
                    required: true,
                    message: 'Proszę podać adres URL',
                },
            ]}
        >
            <Input
            // addonBefore=""
            />
        </Form.Item>
    );
};

export default Url;
